import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ddc276e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  key: 0,
  class: "before-first-visit-block"
}
const _hoisted_3 = {
  key: 1,
  class: "progress-block"
}
const _hoisted_4 = {
  key: 2,
  class: "upcoming-block"
}
const _hoisted_5 = {
  key: 3,
  class: "contact-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_title = _resolveComponent("base-title")!
  const _component_before_first_visit = _resolveComponent("before-first-visit")!
  const _component_progress_stepper = _resolveComponent("progress-stepper")!
  const _component_next_visit_card = _resolveComponent("next-visit-card")!
  const _component_polygon_contact = _resolveComponent("polygon-contact")!
  const _component_main_container_shell = _resolveComponent("main-container-shell")!

  return (_ctx.request)
    ? (_openBlock(), _createBlock(_component_main_container_shell, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.translate('overview.beforeFirstVisitContent'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_base_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.translate('overview.beforeFirstVisitTitle')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_before_first_visit, { class: "expand" })
                ]))
              : _createCommentVNode("", true),
            (_ctx.steps.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_base_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.translate('overview.currentProgressTitle')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_progress_stepper)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.hideUpcomingVisit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_base_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.translate('overview.upcomingVisitTitle')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_next_visit_card, { class: "expand" })
                ]))
              : _createCommentVNode("", true),
            (_ctx.projectManager)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_base_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.translate('overview.polygonContactTitle')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_polygon_contact, { class: "expand" })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}